import React, { memo, useEffect, useState } from 'react';

import DropdownMC from '../../../../../components/DropdownMC';
import CurrencyInputMC from '../../../../../components/CurrencyInputMC';

const ShippingCostFields = ({
  method,
  options,
  shipping_cost_id,
  getValues,
  tCommon,
  loadingShippingCosts
}) => {
  const [customKeyTrigger, setCustomKeyTrigger] = useState(0);

  useEffect(() => {
    if (shipping_cost_id === 'custom') {
      setCustomKeyTrigger((prev) => prev + 1);
    }
  }, [shipping_cost_id]);

  if (loadingShippingCosts) return null;

  return (
    <div className="tw-flex tw-flex-col tw-w-full tw-gap-2">
      {method === "location_cost" ? (
        <DropdownMC
          id="shipping_cost_id"
          name="shipping_cost_id"
          label={tCommon('form.shippingCost')}
          options={options}
          defaultValue={getValues('shipping_cost_id')}
          useFloatingLabel
        />
      ) : (
        <CurrencyInputMC
          id="shipping_value"
          name="shipping_value"
          label={tCommon('form.value')}
          useFloatingLabel
        />
      )}

      {method === "location_cost" && shipping_cost_id === 'custom' && (
        <div className="tw-w-full">
          <CurrencyInputMC
            key={`custom-shipping-${customKeyTrigger}`}
            id="shipping_value"
            name="shipping_value"
            label={tCommon('form.customValue')}
            useFloatingLabel
          />
        </div>
      )}
    </div>
  );
};

export default memo(ShippingCostFields);
